module.exports = __webpack_public_path__ + "static/media/inventory.31f2eab8.svg";